import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import liwazaLogo from '../assets/liwaza-logo.png';
import './Authentication.css';
import { API_BASE_URL, toastdisplay } from '../utils/utils';
import { getErrorMessage } from '../utils/getErrorMessage';
import { getTurnstileToken } from '../utils/turnstile';
const serverURL = API_BASE_URL;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({
    show: false,
    message: '',
    success: true,
  });

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setErrors({});

    if (!email) {
      setErrors({ email: 'Email is required.' });
      return;
    } else if (!validateEmail(email)) {
      setErrors({ email: 'Please enter a valid email address.' });
      return;
    }

    try {
      const captcha_token = await getTurnstileToken();
      const response = await fetch(`${serverURL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, captcha_token }),
      });

      const data = await response.json();
      if (!response.ok) {
        const message = getErrorMessage(
          data.detail ?? data,
          'Error sending reset link.'
        );
        toastdisplay(message, false, 2000, setToast);
        throw new Error(message);
      }

      toastdisplay(
        'Password reset link sent! Check your email.',
        true,
        2000,
        setToast
      );
    } catch (err) {
      toastdisplay(
        err.message || 'Error sending reset link.',
        false,
        2000,
        setToast
      );
    }
  };

  return (
    <div className="liwaza-layout">
      <div style={{ width: '100%', maxWidth: 400, marginBottom: 8 }}>
        <img
          src={liwazaLogo}
          alt="Liwaza Logo"
          style={{ height: '32px', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
      </div>

      <form className="liwaza-form" onSubmit={handleForgotPassword}>
        <h1 className="liwaza-title">Forgot Password?</h1>
        <p className="liwaza-subtitle">
          Enter your email to receive a password reset link.
        </p>

        <div className="liwaza-field">
          <label htmlFor="email">Email address</label>
          <div className="liwaza-input-wrapper">
            <input
              id="email"
              type="email"
              value={email}
              placeholder="you@email.com"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          {errors.email && (
            <p className="text-danger mt-1" style={{ fontSize: '13px' }}>
              {errors.email}
            </p>
          )}
        </div>

        <button className="btn-lwz-primary w-100 mt-3" type="submit">
          Send reset link
        </button>

        <button
          type="button"
          className="btn-lwz-outline w-100 mt-2"
          onClick={() => navigate('/login')}
        >
          Back to login
        </button>
      </form>

      <div style={{ marginTop: '16px', textAlign: 'center' }}>
        <a href="/terms" className="liwaza-legal-link">
          Terms and conditions
        </a>
      </div>

      {toast.show && (
        <div
          className={`toast-notification ${toast.success ? 'success' : 'error'}`}
        >
          <span className="toast-icon">{toast.success ? '✔️' : '❌'}</span>
          <span>{toast.message}</span>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
